<template>
  <div>
    <!--  -->
    <B1 />

    <B2 />

    <B3 />

    <B4 />

    <B5 />

    <B6 v-if="!isMobile" />

    <Customer
      title="我们服务的大型企业客户"
      entitle="Large enterprise customers we serve"
    />
  </div>
</template>

<script>
import B1 from "./components/b1.vue";
import B2 from "./components/b2.vue";
import B3 from "./components/b3.vue";
import B4 from "./components/b4.vue";
import B5 from "./components/b5.vue";
import B6 from "./components/b6.vue";
import Customer from "../layout/components/customer.vue";
export default {
  components: {
    B1,
    B2,
    B3,
    B4,
    B5,
    B6,
    Customer,
  },
};
</script>

<style>
</style>